import { render, staticRenderFns } from "./OrderException.vue?vue&type=template&id=4e9ca467&scoped=true&"
import script from "./OrderException.vue?vue&type=script&lang=js&"
export * from "./OrderException.vue?vue&type=script&lang=js&"
import style0 from "./OrderException.vue?vue&type=style&index=0&id=4e9ca467&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9ca467",
  null
  
)

component.options.__file = "OrderException.vue"
export default component.exports